<template>
	
	
	
	<div style="width: 100%;">
		   
		   <!-- <img style="width: 100%;;" src="../assets/001_0992.jpg"/> -->
		   <img style="width: 100%;" src="../assets/cc1.png"/>

		   <div style="width: 100%;height: 20vw;display: flex;flex-direction: column;align-items: center;">
				<div style="height: 100%;width: 90%; display: flex;flex-direction: column;">
					<div style="display: flex;height: 50%;width: 100%;flex-direction: column;font-size: 5vw;font-weight: 600;font-family:mm;justify-content: center;align-items: center;margin-top: 5%;">
						<div>We would love to hear from you!</div>
					</div>
					<div style="display: flex;width: 100%;height: 50%;flex-direction: column;align-items: center;justify-content: center;">
						<div style="font-size: 2vw;display: flex;width: 90%;font-weight: 600;justify-content: center;">Questions? Concerns? Opinions? Suggestions?</div>
						<div style="font-size: 1.5vw;display: flex;width: 90%;font-weight: 550;margin-top: 1%;justify-content: center;">Fill in the form and we will revert within the next business day.</div>
					</div>
				</div>
				
		   </div>
		   
<!-- 		   <div style="width: 100%;height: 30vw;display: flex;justify-content: space-around;margin-top: 5%;margin-bottom: 5%;">
			   <img style="width: 45%;height: 100%;" src="../assets/cc2.png"/>
			   <img style="width: 45%;height: 100%;" src="../assets/cc3.png"/>
		   </div> -->
			
		     
			   
			  
	
	
		   
		   <div class="a7">
		     <div style="display: flex; width: 100%; height: 80%; ">
		       <div style="display: flex;width: 100%;height: 40vw;margin-top: 5%;margin-bottom: 5%;justify-content: space-around;">
		       			   <img style="width: 32%;height: 100%;" src="../assets/aa4.png"/>
		       			   <img style="width: 32%;height: 100%;" src="../assets/aa5.png"/>
		       			   <img style="width: 32%;height: 100%;" src="../assets/aa6.png"/>
		       </div>
		     </div>
			 <div style="display: flex;width: 100%;height: 15%;justify-content: center;align-items: center;">
				 <div style="font-size: 3vw;background-color: rgba(255, 255, 255, 0.5);backdrop-filter: blur(7px);border-radius: 5vw;margin-right: 3%;padding: 2%;">Contact us:</div>
				 <div style="font-size: 3vw;font-weight: 500;">gncpharma@glutaxultima.com</div>
				 
			 </div>
		     
		     
		   </div>


		   
		   
			
		   
		   
		   <!-- 底部样式实现 -->
		   
		   
	   </div>
</template>

<script scoped>
export default {   
	data() {
	  return {
	     form: {
	             firstName: '',
	             lastName: '',
	             email: '',
	             message: ''
	           }
	  }
	},
	mounted() {
		const spans = document.querySelectorAll('p span');
		
		const numLetters = spans.length;
		
		spans.forEach(function(span, i) {
		    const mappedIndex = i - (numLetters / 2)
		    span.style.animationDelay = (mappedIndex * 0.25) + 's';
		});
}
};
</script>

<style >
	
	.a7{
		
		width: 100%;
		height: 60vw;
		display: flex; 
	    flex-direction: column;
		border-radius: 10px;
		background-color: #E5E5E5;
		margin-top: 5%;
		margin-bottom: 5%;
	}
	 
	

	

	
</style>















